import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "./components/common.css";
import { Home } from "./Pages/Home";
import PrivacyPolicy from "./Pages/policy/PrivacyPolicy";
import { scrollToForm, ScrollToTop } from "./components/utility/utility";
import { RefundPolicy } from "./Pages/policy/refundPolicy";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import TermsAndConditions from "./Pages/policy/terms";
import Blog from "./Pages/blog/Blog";
import BlogDetail from "./Pages/blog/detailPage/BlogDetail";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header onBookDemo={scrollToForm} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/blogs" element={<Blog />} />
         <Route path="/blogs/:slug" element={<BlogDetail />} />
      </Routes>
      <Footer onBookDemo={scrollToForm} />
    </BrowserRouter>
  );
}

export default App;